import routesSample from "../pages/samples/utils/routes";

const portalRoutes = [routesSample];

export default portalRoutes;
